
/**
 * Singleton für globale Eigenschaften zur AGT Opazimeter Kalibrierung
 */

import { action, observable } from 'mobx';

import { provideSingleton } from '../utils/decorators';
import { IObjektVorlage } from '../models/ApiTypes';
import { KalibrierungStore } from './KalibrierungStore';

@provideSingleton(AgtOpazimeterKalibrierungStore)
export class AgtOpazimeterKalibrierungStore extends KalibrierungStore {

  @observable messunsicherheitAnwenden: boolean = false;
  @observable eingabeKorrigierterKoeffizient: boolean = false;
  @observable objektVorlage: IObjektVorlage | undefined = undefined;
  @observable justage: boolean = false;

  @action setMessunsicherheitAnwenden(value: boolean) {
    this.messunsicherheitAnwenden = value;
  }

  @action setEingabeKorrigierterKoeffizient(value: boolean) {
    this.eingabeKorrigierterKoeffizient = value;
  }

  @action setObjektVorlage(value: IObjektVorlage | undefined) {
    this.objektVorlage = value;
  }

  @action setJustage(value: boolean) {
    this.justage = value;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/AgtOpazimeterKalibrierungStore.ts